<div class="container">
  <div class="program-select">
    <div class="button-container">
      <button mat-raised-button [matMenuTriggerFor]="fundsMenu">
        Funds and Allowances
      </button>
      <mat-menu #fundsMenu="matMenu" overlapTrigger="false">
        <button mat-menu-item (click)="selectProgram('bdf', '')">BDF</button>
        <button mat-menu-item (click)="selectProgram('inventoryRebalance', '')">
          Inventory Rebalance
        </button>
        <button mat-menu-item (click)="selectProgram('defectiveGoods', '')">
          Defective Goods
        </button>
      </mat-menu>
      <button mat-raised-button [matMenuTriggerFor]="rebateMenu">
        Rebate Program
      </button>
      <mat-menu #rebateMenu="matMenu" overlapTrigger="false">
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'Wholesale')"
        >
          Rebate Terms & Conditions WholeSale
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'WC')"
        >
          Rebate Terms & Conditions WC
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'CHD')"
        >
          Rebate Terms & Conditions CHD
        </button>
        <button 
        mat-menu-item
        (click)="selectProgram('rebateTermsConditions', 'CHD+')"
      >
        Rebate Terms & Conditions CHD+
      </button>
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'Res Wholesale')"
        >
          Rebate Terms & Conditions Res Wholesale
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'RESSF')"
        >
          Rebate Terms & Conditions RESSF
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('rebateTermsConditions', 'MultiFamily')"
        >
          Rebate Terms & Conditions Multi Family
        </button>
        <button mat-menu-item (click)="selectProgram('cgp', '')">
          Networked Product
        </button>
        <button mat-menu-item (click)="selectProgram('rebateCalc', '')">
          Rebate Calculator
        </button>
      </mat-menu>
      <button mat-raised-button [matMenuTriggerFor]="reportingMenu">
        Reporting Instructions
      </button>
      <mat-menu #reportingMenu="matMenu" overlapTrigger="false">
        <button mat-menu-item (click)="selectProgram('zipCode', '')">
          Zip Code Reporting
        </button>
      </mat-menu>
      <button mat-raised-button [matMenuTriggerFor]="freightMenu">
        Freight Program
      </button>
      <mat-menu #freightMenu="matMenu" overlapTrigger="false" yPosition="below" class="scrollable-menu">
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'CHD/AD/Legacy')"
        >
          CHD/AD/Legacy
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Wholesale/MRO')"
        >
          Wholesale/MRO
        </button>
        <button mat-menu-item (click)="selectProgram('freight', 'ResPro')">
          ResPro
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'International Direct')"
        >
          International Direct
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Collect')"
        >
          Custom - Collect
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Prepaid')"
        >
          Custom - Prepaid
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Other')"
        >
          Custom - Other
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Intercompany')"
        >
          Intercompany
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'CHD/AD/Legacy', 'Canada')"
        >
          CHD/AD/Legacy (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Wholesale/MRO', 'Canada')"
        >
          Wholesale/MRO (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'ResPro', 'Canada')"
        >
          ResPro (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'International Direct', 'Canada')"
        >
          International Direct (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Collect', 'Canada')"
        >
          Custom - Collect (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Prepaid', 'Canada')"
        >
          Custom - Prepaid (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Custom - Other', 'Canada')"
        >
          Custom - Other (Canada)
        </button>
        <button
          mat-menu-item
          (click)="selectProgram('freight', 'Intercompany', 'Canada')"
        >
          Intercompany (Canada)
        </button>
      </mat-menu>
      <button mat-raised-button (click)="selectProgram('pacsOem', '')">
        PACS OEM
      </button>
      <button mat-raised-button [matMenuTriggerFor]="clbMenu">
        Program Resources
      </button>
      <mat-menu #clbMenu="matMenu" overlapTrigger="false">
        <button mat-menu-item (click)="selectProgram('clbIntegrator', '')">
          Integrator Program
        </button>
        <button mat-menu-item (click)="selectProgram('clbLocksmith', '')">
          Locksmith Program
        </button>
        <button mat-menu-item (click)="selectProgram('clbSingleFamily', '')">
          Single Family Program
        </button>
      </mat-menu>
    </div>
    <div>
      <mat-divider></mat-divider>
      <mat-progress-bar
        *ngIf="isLoading === true"
        mode="indeterminate"
        color="accent"
      ></mat-progress-bar>
    </div>
  </div>
  <div class="year-select-container">
    <div class="year-select">
      <mat-button-toggle-group
        [(ngModel)]="defaultYear"
        (change)="selectYear($event)"
        aria-label="Year Select"
      >
        <mat-button-toggle [value]="previousYear"
          >Previous Year</mat-button-toggle
        >
        <mat-button-toggle [value]="currentYear"
          >Current Year</mat-button-toggle
        >
        <mat-button-toggle [value]="nextYear">Next Year</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="edit" *ngIf="preview === false">
    <div class="info">
      <button mat-icon-button (click)="toggleLegend()">
        <mat-icon>info</mat-icon>
      </button>
      <div
        [@openClose]="isOpen ? 'open' : 'closed'"
        class="legend-container mat-elevation-z3"
      >
        <div class="info-header">
          <h4>Markdown Information</h4>
          <mat-divider></mat-divider>
        </div>
        <div class="info-container">
          <h5>Dynamic Values</h5>
          <mat-divider></mat-divider>
          <ul>
            <li>
              <p>BDF Current Year Funds: &#64;&#64;bdfamount&#64;&#64;</p>
            </li>
            <li>
              <p>Inventory Rebalance Percent: &#64;&#64;inventoryrebalancepercent&#64;&#64;</p>
            </li>
            <li>
              <p>Inventory Rebalance Amount: &#64;&#64;inventoryrebalanceamount&#64;&#64;</p>
            </li>
            <li>
              <p>Defective Goods Percent: &#64;&#64;defectivegoodspercent&#64;&#64;</p>
            </li>
          </ul>
          <h5>Headings</h5>
          <mat-divider></mat-divider>
          <p>h1 Heading: #</p>
          <p>h2 Heading: ##</p>
          <p>h3 Heading: ###</p>
          <p>h4 Heading: ####</p>
          <p>h5 Heading: #####</p>
          <p>h6 Heading: ######</p>
          <h5>Emphasis</h5>
          <mat-divider></mat-divider>
          <p>Bold: **text goes here**</p>
          <p>Italics: _text goes here_</p>
          <p>Strikethrough: ~~text goes here~~</p>
          <p>Combined Emphasis: **text goes _here_**</p>
          <h5>Lists</h5>
          <mat-divider></mat-divider>
          <p><strong>Unordered:</strong></p>
          <p>* valid bullet</p>
          <p>- valid bullet</p>
          <p>+ valid bullet</p>
          <hr />
          <p><strong>Ordered:</strong></p>
          <p>1. use numbers to show order</p>
          <p>2. this will be number 2</p>
          <p>3. this will be number 3</p>
          <h5>Tables</h5>
          <mat-divider></mat-divider>
          <p><strong>How to:</strong></p>
          <p>
            Tables are created by adding pipes as dividers between each cell,
            and by adding a line of dashes (also separated by bars) beneath the
            header (this line of dashes is required).
          </p>
          <hr />
          <ul>
            <li>
              <p>pipes do not need to be vertically aligned.</p>
            </li>
            <li>
              <p>pipes do not need to be vertically aligned.</p>
            </li>
            <li>
              <p>
                three or more dashes must be used for each cell in the separator
                row.
              </p>
            </li>
          </ul>
          <hr />
          <p><strong>Example:</strong></p>
          <p>| Option | Description |</p>
          <p>| ----------- | ------------------ |</p>
          <p>| data | add info |</p>
        </div>
      </div>
    </div>
    <div class="edit-content">
      <div class="edit-content-description">
        <label for="textarea">Summary Description</label>
        <textarea [(ngModel)]="displayedDescription" rows="2"></textarea>
      </div>
      <div class="edit-content-content">
        <label for="textarea">Program Content</label>
        <textarea [(ngModel)]="displayedMarkdown"></textarea>
      </div>
    </div>
    <div class="preview-button">
      <button mat-raised-button (click)="openPreview()">
        Preview Program Content
      </button>
      <button mat-raised-button (click)="updateMarkdown()">
        Submit Program Content
      </button>
    </div>
  </div>
</div>
